const title = "Client Dashboard";

export { title };
